import { Enums } from '@bode-canada/core';
import ControlProps from '../../../mixins/ControlProps';
import { FileUploaderProperty } from '../enums';
import InputProps from '../../../shared/input/mixins/InputProps';
import { InputProperty } from '../../../shared/input/enums';

const DEFAULT_MAX_FILE_SIZE = 5000000;

const FileUploaderProps = {
  props: {
    ...ControlProps.props,
    [FileUploaderProperty.FillType]: InputProps.props[InputProperty.FillType],
    [FileUploaderProperty.MaxSize]: {
      default: DEFAULT_MAX_FILE_SIZE,
      type: Number,
    },
    [FileUploaderProperty.Extensions]: {
      default: () => Object.values(Enums.DocumentFileExtensionEnum),
      type: Array,
    },
  },
};

export default FileUploaderProps;
